import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row breadcrumb-row" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ancestries, (anc, index) => {
      return (_openBlock(), _createElementBlock("span", { key: index }, [
        _createElementVNode("a", {
          href: "#",
          onClick: _withModifiers(($event: any) => (_ctx.onClickLink(anc.pathObj)), ["prevent"])
        }, _toDisplayString(anc.name), 9, _hoisted_2),
        _cache[0] || (_cache[0] = _createTextVNode(" > ", -1))
      ]))
    }), 128)),
    _createElementVNode("span", null, _toDisplayString(_ctx.here), 1)
  ]))
}